import React from "react";
import { Icon } from "../Icon/icon";

export interface IVerticalProgressProps {
  sectionLabel: string;
  steps: VerticalStep[];
  isCollapsible?: boolean;
}

interface IVerticalProgressState {
  isCollapsed: boolean;
}

export interface VerticalStep {
  date: string;
  status: string;
  details?: string;
  icon: VerticalProgressIcon | string;
  isActive: boolean;
}

export enum VerticalProgressIcon {
  NoIcon = "NoIcon",
  Empty = "Empty",
  Checkmark = "Checkmark",
  Attention = "Attention",
}

export class VerticalProgress extends React.Component<
  IVerticalProgressProps,
  IVerticalProgressState
> {
  constructor(props: IVerticalProgressProps) {
    super(props);
    this.state = {
      isCollapsed: true,
    };
  }

  static defaultProps = {
    isCollapsible: false,
  };

  getIconString = (icon: string): string => {
    if (
      icon === VerticalProgressIcon.Empty ||
      icon === VerticalProgressIcon.NoIcon
    )
      return "";
    return icon;
  };

  flipExpanded = () => {
    this.setState({
      isCollapsed: !!!this.state.isCollapsed,
    });
  };

  getSpokenText = (step: VerticalStep, stepNumber: number): string => {
    var stepOutput = "Steg " + stepNumber;
    var datumOutput =
      step.date && step.date.trim().length > 0
        ? " med datum " + step.date + ": "
        : ": ";
    var statusOutput = step.status;
    var extraInfo = !!step.details ? ". " + step.details : "";

    return stepOutput + datumOutput + statusOutput + extraInfo;
  };

  public render() {
    const { sectionLabel, steps, isCollapsible } = this.props;
    const { isCollapsed } = this.state;

    {
      /*This is not so clear, how it is decided to make it collapsible?*/
    }
    const shouldCollapse = isCollapsible && steps.length > 3;
    const btnText = isCollapsed ? "Visa mer" : "Visa mindre";

    let sectionClass = "";
    let overlayClass = "";
    let arrowClass = "";
    let expanded = "";

    if (shouldCollapse) {
      sectionClass = isCollapsed ? "verticalprogress--collapsed" : "";
      overlayClass = !isCollapsed ? "verticalprogress__overlay--hidden" : "";
      expanded = !isCollapsed ? "verticalprogress--expanded" : "";
      arrowClass = isCollapsed ? "arrow-up--flipped" : "";
    }

    return (
      <section
        className={`verticalprogress ${sectionClass} ${expanded}`}
        aria-label={sectionLabel}
      >
        {steps && (
          <>
            <ol className="verticalprogress__list">
              {steps.map((step, i) => {
                const attentionClass = `${step.details ? "attention" : ""}`;
                const activeClass = `${step.isActive ? "active" : ""}`;
                const noIconClass = `${
                  step.icon == VerticalProgressIcon.NoIcon ? "no-icon" : ""
                }`;
                return (
                  <li
                    key={`vp-item-${i}`}
                    className={`verticalprogress__item ${attentionClass} ${activeClass} ${noIconClass}`}
                  >
                    {this.getIconString(step.icon) && (
                      <Icon
                        className="verticalprogress__icon"
                        iconType={this.getIconString(step.icon)}
                      />
                    )}
                    <div className="sr-only">
                      {this.getSpokenText(step, i + 1)}
                    </div>
                    <div
                      className="verticalprogress__status"
                      aria-hidden="true"
                    >
                      {step.status}
                    </div>
                    {step.details && (
                      <div
                        className="verticalprogress__details"
                        aria-hidden="true"
                      >
                        {step.details}
                      </div>
                    )}
                    {step.date && (
                      <time dateTime={step.date} aria-hidden="true">
                        {step.date}
                      </time>
                    )}
                  </li>
                );
              })}
            </ol>
            {shouldCollapse && (
              <div className={`verticalprogress__overlay ${overlayClass}`}>
                <button
                  className={`stripped-button verticalprogress__overlay__link ${arrowClass}`}
                  onClick={this.flipExpanded}
                >
                  <span>
                    {btnText}
                    <span className={`arrow-up ${arrowClass}`} />
                  </span>
                </button>
              </div>
            )}
          </>
        )}
      </section>
    );
  }
}
